import { AdminxReporterEndpoint } from './adminx-reporter.endpoint';
import { BidKeysManagementEndpoint } from './bidkeys-management.endpoint';
import { BidderEndpoints } from './bidder.endpoints';
import { BidderDomainsEndpoints } from './bidder-domains.endpoints';
import { CampaignSegmentationEndpoint } from './campaign-segmentation.endpoint';
import { CampaignConfigAuditEndpoint } from './campaign-config-audit.endpoint';
import { CampaignsEndpoint } from './campaigns.endpoint';
import { DomainFactorsEndpoint } from './domain-factors.endpoint';
import { CreativesEndpoint } from './creatives.endpoint';
import { CrudEndpoint } from './crud.endpoint';
import { DealsEndpoint } from './deals.endpoint';
import { DestinationsEndpoint } from './destinations.endpoint';
import { DomainMaxLossEndpoint } from './domain-max-loss.endpoint';
import { WebappsCidEndpoint } from './webapps-cid.endpoint';
import { PreferencesEndpoint } from './preferences.endpoint';
import { TestsEndpoint } from './tests.endpoint';
import { UsersEndpoint } from './users.endpoint';

const endpoints = {
	domainFactors: new DomainFactorsEndpoint(),
	campaigns: new CampaignsEndpoint(),
	advertisers: new CrudEndpoint('advertisers'),
	preferences: new PreferencesEndpoint(),
	creatives: new CreativesEndpoint(),
	campaignConfigAudit: new CampaignConfigAuditEndpoint(),
	campaignGroups: new CrudEndpoint('campaign-groups'),
	creativeGroups: new CrudEndpoint('creative-groups'),
	tests: new TestsEndpoint(),
	deals: new DealsEndpoint(),
	jobs: new CrudEndpoint('jobs'),
	cids: new CrudEndpoint('campaigns/webapps-cid-replacer'),
	accounts: new CrudEndpoint('accounts'),
	campaignSegmentations: new CampaignSegmentationEndpoint(),
	report: new AdminxReporterEndpoint(),
	users: new UsersEndpoint(),
	bidKeysManagment: new BidKeysManagementEndpoint(),
	bidder: new BidderEndpoints(),
	bidderDomains: new BidderDomainsEndpoints(),
	domainMaxLoss: new DomainMaxLossEndpoint(),
	destinations: new DestinationsEndpoint(),
	webappsCid: new WebappsCidEndpoint(),
};

export default endpoints;
